// Date 2020-07-14 10:16:17

import emArchBasicData from "@/store/em/archive/EmArchBasicDataStore.js";
import emLocation from "@/store/em/archive/EmLocationStore.js";
import emArchFault from "@/store/em/archive/EmArchFaultStore.js";
import emArchToolKit from "@/store/em/archive/EmArchToolKitStore.js";
import emEquipmentCategory from "@/store/em/archive/EmEquipmentCategoryStore.js";
import emEquipmentLevel from "@/store/em/archive/EmEquipmentLevelStore.js";
import emEquipmentStatus from "@/store/em/archive/EmEquipmentStatusStore.js";
import emArchManufacturer from "@/store/em/archive/EmArchManufacturerStore.js";
import emArchCostStatistic from "@/store/em/archive/EmArchCostStatisticStore.js";
import emArchCostStatisticType from "@/store/em/archive/EmArchCostStatisticTypeStore.js";
import emArchFaultFeatureTag from "@/store/em/archive/EmArchFaultFeatureTagStore.js";
import emArchFaultRefTag from "@/store/em/archive/EmArchFaultRefTagStore.js";
import emArchFaultType from "@/store/em/archive/EmArchFaultTypeStore.js";
import emArchLaborCostStand from "@/store/em/archive/EmArchLaborCostStandStore.js";
import emArchSppUnloadRecord from "@/store/em/archive/EmArchSppUnloadRecordStore.js";
import emArchToolKitDetail from "@/store/em/archive/EmArchToolKitDetailStore.js";
import emArchSupplier from "@/store/em/archive/EmArchSupplierStore";
import emArchBdaREafmBarem from "@/store/em/archive/EmArchBdaREafmBaremStore";
import emCapitalSource from "@/store/em/archive/EmCapitalSourceStore.js";
import emArchBasicDataRelMaterial from "@/store/em/archive/EmArchBasicDataRelMaterialStore.js";
import emArchBdaRelSppBrs from "@/store/em/archive/EmArchBdaRelSppBrsStore.js";
import emArchTool from "@/store/em/archive/EmArchToolStore.js";
import emArchToolChangeDetail from "@/store/em/archive/EmArchToolChangeDetailStore.js";
import emArchToolChangeRecord from "@/store/em/archive/EmArchToolChangeRecordStore.js";
import emArchToolChangeType from "@/store/em/archive/EmArchToolChangeTypeStore.js";
import emArchToolType from "@/store/em/archive/EmArchToolTypeStore.js";
import emArchToolChange from "@/store/em/archive/EmArchToolChangeStore.js";
import emArchScrapProcessAsp from "@/store/em/archive/EmArchScrapProcessAspStore.js";
import emStocktakingTask from "@/store/em/archive/EmStocktakingTaskStore";
import emStocktakingTaskDetail from "@/store/em/archive/EmStocktakingTaskDetailStore";

const genericEntities = [
    'emArchBasicData',
    'emArchBdaRelSppBrs',
    'emLocation',
    'emArchFault',
    'emArchToolKit',
    'emEquipmentCategory',
    'emEquipmentLevel',
    'emEquipmentStatus',
    'emArchManufacturer',
    'emArchCostStatistic',
    'emArchCostStatisticType',
    'emArchFaultFeatureTag',
    'emArchFaultRefTag',
    'emArchFaultType',
    'emArchLaborCostStand',
    'emArchSppUnloadRecord',
    'emArchToolKitDetail',
    'emArchSupplier',
    'emArchBdaREafmBarem',
    'emCapitalSource',
    'emArchBasicDataRelMaterial',
    'emArchTool',
    'emArchToolChangeDetail',
    'emArchToolChangeRecord',
    'emArchToolChangeType',
    'emArchToolType',
    'emArchToolChange',
    'emArchScrapProcessAsp',
    'emStocktakingTask',
    'emStocktakingTaskDetail'

]

const entities = {
    emArchBasicData,
    emArchBdaRelSppBrs,
    emLocation,
    emArchFault,
    emArchToolKit,
    emEquipmentCategory,
    emEquipmentLevel,
    emEquipmentStatus,
    emArchManufacturer,
    emArchCostStatistic,
    emArchCostStatisticType,
    emArchFaultFeatureTag,
    emArchFaultRefTag,
    emArchFaultType,
    emArchLaborCostStand,
    emArchSppUnloadRecord,
    emArchToolKitDetail,
    emArchSupplier,
    emArchBdaREafmBarem,
    emCapitalSource,
    emArchBasicDataRelMaterial,
    emArchTool,
    emArchToolChangeDetail,
    emArchToolChangeRecord,
    emArchToolChangeType,
    emArchToolType,
    emArchToolChange,
    emArchScrapProcessAsp,
    emStocktakingTask,
    emStocktakingTaskDetail
}

export {genericEntities}

export default entities
